/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { TextInput, isEmptyValue } from '@blend/enterprise-components';

import { WrappedInput } from 'id-components/WrappedInput';
import { PasswordField } from 'id-components/PasswordField';
import { FinalFormInputConfig } from 'id-types/helpers';
import { emptyPasswordValidator } from 'id-utils/validators';

const styles = StyleSheet.create({
  fieldWrapper: {
    ':not(:last-child)': {
      marginBottom: 16,
    },
  },
});

export const getPasswordInputConfig = ({
  name = 'password',
  label = 'Password',
  validate = emptyPasswordValidator,
}: Partial<FinalFormInputConfig<TextInput.Props, string>> = {}): FinalFormInputConfig<TextInput.Props, string> => ({
  component: PasswordField,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: { type: 'password' },
  inputComponent: TextInput,
  label,
  labelSize: 'sm',
  name,
  validate,
});

export const getConfirmationCodeInputConfig = ({
  name,
}: {
  name: string;
}): FinalFormInputConfig<TextInput.Props, string> => ({
  autoFocus: true,
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: { type: 'unformattedNumber' },
  inputComponent: TextInput,
  label: 'Code',
  labelSize: 'sm',
  name,
  validate: isEmptyValue('Please input your verification code.'),
});
